import { ArraySerializer, Field, Model, Type } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';

@Model()
export class EntriesEntity {
  @Field()
  label: string;

  @Field()
  url: string;

  @Field()
  name?: string | null;
}

@Model()
export class MenuEntriesEntity {
  @Field()
  label: string;

  @Field()
  url?: string | null;

  @Field()
  name?: string | null;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(EntriesEntity)))
  entries?: EntriesEntity[] | null;
}

@Model()
export class Actions {
  @Field()
  newslettersAndPromotions: string;

  @Field()
  addExistingCard: string;

  @Field()
  registerBusiness: string;

  @Field()
  loginAndSecurity: string;

  @Field()
  logout: string;
}

@Model()
export class AccountActions {
  @Field()
  requestStoreAccess?: string | null;

  @Field()
  newslettersAndPromotions: string;

  @Field()
  addExistingCard: string;

  @Field()
  registerBusiness: string;

  @Field()
  loginAndSecurity: string;

  @Field()
  logout: string;
}

@Model()
export class Translations {
  @Field()
  addExistingCard: string;

  @Field()
  registerBusiness: string;

  @Field()
  personalAccount: string;

  @Field()
  onlineOnly: string;

  @Field()
  onlineAndStoreAccess: string;

  @Field()
  requestStoreAccess: string;

  @Field()
  pendingStoreAccess: string;

  @Field()
  switchAccount: string;

  @Field()
  newslettersAndPromotions: string;

  @Field()
  loginAndSecurity: string;

  @Field()
  logout: string;

  @Field()
  back: string;
}

@Model()
export class Person {
  @Field()
  id: string;

  @Field()
  name: string;

  @Field()
  accountFlyoutHeader: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(MenuEntriesEntity)))
  menuEntries?: MenuEntriesEntity[] | null;

  @Field()
  @Type(new ModelMetadataSerializer(Actions))
  actions: Actions;
}

@Model()
export class AccountsEntity {
  @Field()
  id: string;

  @Field()
  corporateName: string;

  @Field()
  legalAddress: string;

  @Field()
  isHeadQuarter: boolean;

  @Field()
  onlineStatus: string;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(MenuEntriesEntity)))
  menuEntries?: MenuEntriesEntity[] | null;

  @Field()
  @Type(new ModelMetadataSerializer(AccountActions))
  actions: AccountActions;
}

@Model()
export class AccountFlyoutResponse {
  @Field()
  activeContext: string;

  @Field()
  @Type(new ModelMetadataSerializer(Person))
  person: Person;

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(AccountsEntity)))
  accounts?: AccountsEntity[] | null;

  @Field()
  @Type(new ModelMetadataSerializer(Translations))
  translations: Translations;
}

export interface AccountContext {
  id: string;

  label: string;

  footer: string;

  account?: AccountsEntity;

  menuEntries: MenuEntriesEntity[] | null;
}
